/* Enhance Shopify's native sort select without changing its form or filter flow. */
if (!customElements.get('primo-sort')) {
  customElements.define('primo-sort', class extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('select');
      if (!this.select || !this.closest('.primo-collection, .template-search')) return;
      this.querySelectorAll('.primo-sort__trigger, .primo-sort__menu').forEach(node => node.remove());
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.label = this.select.labels?.[0]?.textContent.trim() || 'Sort by';
      this.trigger = document.createElement('button');
      this.trigger.type = 'button';
      this.trigger.className = 'primo-sort__trigger';
      this.trigger.setAttribute('aria-haspopup', 'menu');
      this.trigger.setAttribute('aria-expanded', 'false');
      this.trigger.setAttribute('aria-controls', `${this.select.id}-menu`);
      this.valueLabel = document.createElement('span');
      this.trigger.append(this.valueLabel);
      const caret = this.querySelector('.svg-wrapper');
      if (caret) this.trigger.append(caret.cloneNode(true));
      this.menu = document.createElement('div');
      this.menu.className = 'primo-sort__menu';
      this.menu.id = `${this.select.id}-menu`;
      this.menu.setAttribute('role', 'menu');
      this.menu.setAttribute('aria-label', this.label);
      this.menu.hidden = true;
      this.items = [...this.select.options].map(option => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('role', 'menuitemradio');
        button.tabIndex = -1;
        button.textContent = option.textContent.trim();
        button.dataset.value = option.value;
        button.addEventListener('click', () => {
          const changed = this.select.value !== option.value;
          this.select.value = option.value;
          this.update();
          this.close(true);
          if (changed) this.select.dispatchEvent(new Event('input', { bubbles: true }));
        }, options);
        this.menu.append(button);
        return button;
      });
      this.append(this.trigger, this.menu);
      this.select.hidden = true;
      this.classList.add('is-ready');
      this.update();
      this.trigger.addEventListener('click', () => this.menu.hidden ? this.open() : this.close(), options);
      this.select.addEventListener('change', () => this.update(), options);
      this.addEventListener('keydown', event => this.onKeydown(event), options);
      this.addEventListener('focusout', event => {
        // During pointer focus transfer, activeElement can briefly be body.
        // relatedTarget identifies the destination without hiding the clicked option.
        if (event.relatedTarget && !this.contains(event.relatedTarget)) this.close();
      }, options);
      document.addEventListener('pointerdown', event => {
        if (!this.contains(event.target)) this.close();
      }, options);
    }

    update() {
      this.valueLabel.textContent = this.select.selectedOptions[0]?.textContent.trim() || '';
      this.trigger.setAttribute('aria-label', `${this.label} ${this.valueLabel.textContent}`);
      this.items.forEach(item => item.setAttribute('aria-checked', String(item.dataset.value === this.select.value)));
    }

    open(index = this.items.findIndex(item => item.dataset.value === this.select.value)) {
      this.menu.hidden = false;
      this.trigger.setAttribute('aria-expanded', 'true');
      this.items[Math.max(0, index)]?.focus();
    }

    close(restoreFocus = false) {
      if (!this.menu) return;
      this.menu.hidden = true;
      this.trigger.setAttribute('aria-expanded', 'false');
      if (restoreFocus) this.trigger.focus();
    }

    onKeydown(event) {
      const index = this.items.indexOf(document.activeElement);
      if (event.key === 'Escape' && !this.menu.hidden) {
        event.preventDefault();
        event.stopPropagation();
        this.close(true);
      } else if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
        event.preventDefault();
        if (this.menu.hidden) return this.open(event.key === 'End' ? this.items.length - 1 : undefined);
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.items.length - 1 :
          (index + (event.key === 'ArrowDown' ? 1 : -1) + this.items.length) % this.items.length;
        this.items[next].focus();
      } else if (event.key === 'Tab') {
        this.close(true);
      } else if (event.key.length === 1 && event.key !== ' ' && !event.ctrlKey && !event.metaKey && !event.altKey) {
        const now = Date.now();
        this.search = now - (this.lastKey || 0) < 600 ? (this.search || '') + event.key : event.key;
        this.lastKey = now;
        const match = this.items.findIndex(item => item.textContent.toLowerCase().startsWith(this.search.toLowerCase()));
        if (match >= 0) { event.preventDefault(); this.open(match); }
      }
    }

    disconnectedCallback() {
      this.events?.abort();

    }
  });
}
